<template>
  <div id="stdreq">
    <stdreq-detail :labels="labels[app.nowLang]" :data="index" :columns="columns[app.nowLang].index" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/stdreq/mutation-types'
import stdreqDetail from 'components/stdreq/stdreqDetail'

export default {
  name: 'stdreq',
  data () {
    return {
      app: this.$root.$children[0],
      searchParams: {
        numreql: 'KK-001'
      }
    }
  },
  created () {
    this.receivedStdreqColumnsLabels()
  },
  computed: {
    ...mapGetters({
      indexDisp: types.GET_STDREQ_INDEX_DISP,
      columns: types.GET_STDREQ_COLUMNS,
      labels: types.GET_STDREQ_LABELS,
      index: types.GET_STDREQ_INDEX
    })
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      toggle: types.TOGGLE_STDREQ_PAGE,
      receivedStdreqColumnsLabels: types.RECEIVED_STDREQ_COLUMNS_LABELS,
      receivedStdreqIndex: types.RECEIVED_STDREQ_INDEX
    })
  },
  components: {
    stdreqDetail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?76fcd7ca